import { supabase } from './supabase';
import { fetchAllRows } from './fetchAll';

/**
 * Distinct-user "active" count straight from `app_sessions` (DB truth), not PostHog.
 *
 * This used to call an `admin-analytics` Edge Function that read PostHog, because
 * PostHog was live before `app_sessions` had data. PostHog mixes the mobile app with
 * marketing-site traffic, so the numbers never reconciled with the DB and read as
 * "not accurate" to the founder. `app_sessions` is now populated (rows since
 * 2026-06-19) and admin-readable directly, so this reads it instead.
 *
 * Returns null (never throws) so a missing table / blocked grant can't blank the
 * whole Home dashboard — the card just shows "—" instead of a real zero.
 */
export async function countActiveUsersSince(sinceIso: string): Promise<number | null> {
  try {
    const rows = await fetchAllRows<{ user_id: string | null }>((from, to) =>
      supabase.from('app_sessions').select('user_id').gte('started_at', sinceIso).range(from, to),
    );
    const distinct = new Set(rows.map((r) => r.user_id).filter((id): id is string => Boolean(id)));
    return distinct.size;
  } catch {
    return null;
  }
}
